import React from "react";
import { Box } from "@chakra-ui/react";
import Client from "../panels/Client";
import Tab from "../../../shared/tabs";
import Search from "../../../shared/keywords";
// const Builder = lazy(() => import("../../../builder-refactor"));
import Editor from "../../../Editor";

function Panels({
	lang,
	eventId,
	formik,
	locations,
	activeTab,
	setActiveTab,
	submitClicked,
	pages,
	...rest
}) {
	const options = {
		AlbumText: <Client pages={pages} eventId={eventId} formik={formik} lang={lang} />,
		Keywords: <Search formik={formik} lang={lang} type="events" />,
		// Builder: <Builder formik={formik} refer={"events"} variant="gallery" />,
		Builder: <Editor formik={formik} refer={"events"} variant="gallery" />,
	};

	const fields = [["title", "description", "location"], ["keywords"], ["gallery"]];

	return (
		<Box
			overflow="hidden"
			display="flex"
			flexDir="column"
			justifyContent="space-between"
			height={{ base: "100%", md: "calc(100% - 4rem)" }}
			{...rest}
		>
			<Tab
				submitClicked={submitClicked}
				formik={formik}
				fields={fields}
				active={activeTab}
				setActive={setActiveTab}
				options={options}
			/>
		</Box>
	);
}

export default Panels;
